import { useState, useCallback } from "react";
import type { PDFDocumentProxy } from "pdfjs-dist";

interface UsePdfDocumentResult {
  numPages: number;
  isLoaded: boolean;
  loadedSrc: string | null;
  pdfDocument: PDFDocumentProxy | null;
  onDocumentLoadSuccess: (pdf: PDFDocumentProxy) => void;
  onDocumentLoadError: () => void;
}

export const usePdfDocument = (src: string): UsePdfDocumentResult => {
  const [numPages, setNumPages] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);
  const [pdfDocument, setPdfDocument] = useState<PDFDocumentProxy | null>(null);

  const onDocumentLoadSuccess = useCallback(
    (pdf: PDFDocumentProxy) => {
      setNumPages(pdf.numPages);
      setIsLoaded(true);
      setLoadedSrc(src);
      setPdfDocument(pdf);
    },
    [src]
  );

  const onDocumentLoadError = useCallback(() => {
    setNumPages(0);
    setIsLoaded(false);
    setLoadedSrc(null);
    setPdfDocument(null);
  }, []);

  return {
    numPages,
    isLoaded,
    loadedSrc,
    pdfDocument,
    onDocumentLoadSuccess,
    onDocumentLoadError,
  };
};
